<template>
  <div class="d-timetal__container">
    <div class="d-guides">
      <StilGuides :video-id="'5Id4TeuHMvI?start=233'"
                  textForLink="Guide: Se videoguide for kompetencedækning">
      </StilGuides>
      <p class="italic" v-if="isShowSubjects"><b>Bemærk:</b> Opret, slet eller redigere fag påvirker kun indberetningsdata'en - ikke i resten af Docendo</p>
    </div>
    <h3 class="text-explainer text-explainer__error" v-if="usersSorted.length < 1">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="tw-icon icon-important">
        <path class="primary" d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"/>
        <path class="secondary"
              d="M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"/>
      </svg>
      Der er ingen personer udfyldt med stilling og CPR. Gå tilbage til "1. Undervisningskompetencer"
    </h3>
    <KompetenceIndberetningDaekningUser
      v-for="user in usersSorted"
      :user="user"
      :klokketimetyper="klokketimetyper"
      :dbStilData="dbStilData"
      @updateStil="$emit('updateStil', $event)">
    </KompetenceIndberetningDaekningUser>
  </div>
</template>

<script>
import eventbus from '../../../eventbus'
import KompetenceIndberetningDaekningUser from './KompetenceIndberetningDaekningUser'
import StilGuides from './../StilGuides'

export default {
  components: {KompetenceIndberetningDaekningUser, StilGuides},
  props: {
    standardSubjects: {
      type: Array,
      default: () => []
    },
    dbStilData: {
      type: Object,
      default: () => {
      }
    },
    stilData: {
      type: Object,
      default: () => {
      }
    },
    isShowSubjects: {
      type: Boolean,
      default: false
    },
    usersSSNHash: {
      type: Object,
      default: () => {
      }
    },
    klokketimetyper: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    users () {
      return this.stilData.laerere.filter(user => this.usersSSNHash[user.cpr]).map(user => {
        const vName = this.usersSSNHash[user.cpr].name
        let vFag = this.usersWithSubjectIdsMap[user.cpr] ? this.usersWithSubjectIdsMap[user.cpr] : []
        vFag = vFag.sort((a, b) => {
          return a.fag_navn.localeCompare(b.fag_navn, 'da', {
            numeric: true,
            sensitivity: 'base'
          })
        })
        return {...user, vName, vFag}
      })
    },
    usersSorted () {
      return this.users.sort((a, b) => {
        return a.vName.localeCompare(b.vName, 'da', {
          numeric: true,
          sensitivity: 'base'
        })
      })
    },
    usersWithSubjectIdsMap () {
      // {cpr: [klasse_id _ fag_id]}
      const fagOnUserMap = {}
      this.stilData.klasser.forEach(klasse => {
        klasse.fag.forEach(fag => {
          fag.laerere.forEach(learer => {
            const vUid = klasse.klasse_id + '_' + fag.fag_id
            const vFag = {
              vUid: vUid,
              cpr: learer.cpr,
              klassebetegnelse: klasse.klassebetegnelse,
              klasse_id: klasse.klasse_id,
              klasse_type: klasse.klasse_type,
              klasse_klokketimer: fag.klokketimer,
              fag_id: fag.fag_id,
              fag_navn: fag.fag_navn,
              fagkode: fag.fagkode,
              learer_klokketimer: learer.klokketimer,
              klokketimer_type: learer.klokketimer_type
            }
            if (learer.cpr) {
              if (!fagOnUserMap[learer.cpr]) {
                fagOnUserMap[learer.cpr] = [vFag]
              } else {
                fagOnUserMap[learer.cpr].push(vFag)
              }
            }
          })
        })
      })
      return fagOnUserMap
    }
  },
  methods: {
    isValidNumber (input) {
      if (isNaN(input)) {
        return false
      }
      if (input < 0) {
        return false
      }
      return true
    },
    updateStilKlasseFagLaerer (user, itemFag, prop, val, target) {
      const report = JSON.parse(JSON.stringify(this.dbStilData))
      const klasseIdx = report.klasser.findIndex(klasse => klasse.klasse_id === itemFag.klasse_id)
      const fagIdx = report.klasser[klasseIdx].fag.findIndex(fag => fag.fag_id === itemFag.fag_id)
      const teacherIdx = report.klasser[klasseIdx].fag[fagIdx]['laerere'].findIndex(teacher => teacher.cpr === itemFag.cpr)
      const oldValue = report.klasser[klasseIdx].fag[fagIdx]['laerere'][teacherIdx][prop]
      if (oldValue === val) {
        return
      }
      report.klasser[klasseIdx].fag[fagIdx]['laerere'][teacherIdx][prop] = val
      if (prop === 'klokketimer' && !this.isValidNumber(val)) {
        eventbus.toast = {text: 'Skal være et tal, 0 eller højere', success: false}
        target.value = oldValue
        return
      }
      this.$emit('updateStil', report)
    }
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.d-guides {
  border: 1px solid rgba(204, 204, 204, 0.75);
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.d-timetal__container {
  padding: 2rem 1rem;
  border: 1px solid #d8d8d8;
  width: 100%;
  max-width: 1100px;
  border-radius: 4px;
}

.text-explainer {
  font-weight: normal !important;
}

.text-explainer__error {
  border: 1px solid #ccc;
  padding: 4rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: normal !important;
}

.text-explainer__error .tw-icon {
  width: 3rem;
  margin-right: 1rem;
}

.subject {
  width: 165px;
  display: inline-block;
  border-radius: 4px;
  padding: 0px 8px;
  background: transparent;
  border: 1px solid #ccc;
  font-weight: bold;
}

.d-select__small {
  width: 265px !important;
}

</style>



// WEBPACK FOOTER //
// KompetenceIndberetningDaekning.vue?04a47e98